export default __webpack_public_path__ + "static/media/Aviso_Reparto.21f32d83.jpg";